export default class CustomerIdentifierModel {
    public channel: string = ''
    public customerId: string = ''   
  }